(function () {
  'use strict';

  /* =========================================================
     THE VALORYS
     CONFIGURATEUR MAILLOT BINATIONAL
     PERFORMANCE V2
     ========================================================= */

  const SOURCE_WIDTH = 3000;
  const SOURCE_HEIGHT = 3000;

  /*
   * Le masque historique a été dessiné
   * dans un repère 3000 × 3000.
   *
   * Le canvas live tourne désormais en 1200 × 1200
   * et les coordonnées sont automatiquement redimensionnées.
   */
  const LIVE_CANVAS_WIDTH = 1200;
  const LIVE_CANVAS_HEIGHT = 1200;


  /* =========================================================
     CONFIGURATION PERSISTENCE / DEEP LINKS
     ========================================================= */

  const CONFIG_VERSION = 2;
  const STORAGE_PREFIX = 'valorys:configurator:v2:';

  const VALORYS_QUERY_KEYS = [
    'v_source',
    'v_a',
    'v_b',
    'v_view',
    'v_floc',
    'v_name',
    'v_num',
    'v_name2',
    'v_size',
    'v_qty',
    'v_edit_group',
    'v_edit_main',
    'v_edit_service'
  ];


  /* =========================================================
     MASK
     ========================================================= */

  const MASK_POINTS = [
    [1500,0],[1579,0],[1507,265],[1511,369],[1522,432],[1516,472],[1485,380],[1485,400],
    [1506,486],[1507,508],[1504,506],[1503,536],[1500,544],[1495,544],[1491,536],[1479,558],
    [1471,558],[1473,601],[1451,520],[1474,641],[1455,609],[1443,607],[1434,575],[1423,554],
    [1419,567],[1440,661],[1427,655],[1417,633],[1427,673],[1424,681],[1428,699],[1427,705],
    [1423,703],[1416,675],[1409,703],[1434,796],[1427,798],[1432,826],[1428,850],[1435,868],
    [1453,884],[1462,888],[1463,904],[1459,916],[1452,918],[1456,932],[1457,967],[1468,987],
    [1462,1005],[1451,1019],[1450,1033],[1447,1049],[1442,1051],[1432,1067],[1436,1083],[1437,1091],
    [1433,1095],[1433,1103],[1445,1128],[1450,1126],[1458,1136],[1456,1150],[1475,1198],[1487,1210],
    [1490,1212],[1490,1224],[1503,1228],[1508,1232],[1520,1290],[1498,1252],[1542,1407],[1558,1512],
    [1565,1534],[1569,1572],[1574,1580],[1589,1624],[1577,1624],[1526,1465],[1527,1508],[1535,1518],
    [1569,1642],[1569,1711],[1559,1711],[1554,1705],[1550,1719],[1534,1721],[1526,1709],[1541,1751],
    [1544,1793],[1535,1771],[1520,1769],[1502,1733],[1498,1711],[1495,1725],[1485,1721],[1520,1912],
    [1497,1900],[1505,1956],[1518,1974],[1522,1998],[1523,2028],[1529,2040],[1531,2065],[1537,2103],
    [1539,2135],[1541,2159],[1536,2177],[1532,2177],[1522,2193],[1524,2203],[1525,2215],[1507,2250],
    [1507,2260],[1512,2276],[1518,2280],[1530,2302],[1538,2352],[1555,2378],[1546,2392],[1561,2394],
    [1570,2443],[1555,2410],[1588,2585],[1574,2547],[1587,2634],[1576,2617],[1555,2569],[1574,2644],
    [1559,2607],[1534,2780],[1575,2939],[1500,3000]
  ];


  /* =========================================================
     CACHES
     ========================================================= */

  /*
   * Image réellement utilisée dans le canvas.
   *
   * On stocke une Promise + l'état "ready"
   * pour savoir si le loader est réellement nécessaire.
   */
  const imageCache = new Map();

  /*
   * Demi-drapeaux.
   * Avant, ils étaient recréés à chaque rendu.
   */
  const halfFlagCache = new Map();

  /*
   * Path2D du masque.
   * Avant, les centaines de points étaient reconstruits
   * à chaque frappe / changement / rendu.
   */
  const maskPathCache = new Map();

  /*
   * Préchargement réseau temporaire.
   *
   * On ne garde PAS ces images en mémoire après chargement.
   * Le but est uniquement de remplir le cache HTTP du navigateur.
   */
  const prefetchPool = new Set();
  const prefetchedUrls = new Set();


  /* =========================================================
     FONT CACHE
     ========================================================= */

  let redigPromise = null;


  /* =========================================================
     CDN CONNECTION HINTS
     ========================================================= */

  function ensureCdnHints() {
    if (!document.head) return;

    if (!document.querySelector('link[data-valorys-jsdelivr-preconnect]')) {
      const preconnect = document.createElement('link');

      preconnect.rel = 'preconnect';
      preconnect.href = 'https://cdn.jsdelivr.net';
      preconnect.crossOrigin = 'anonymous';
      preconnect.dataset.valorysJsdelivrPreconnect = 'true';

      document.head.appendChild(preconnect);
    }

    if (!document.querySelector('link[data-valorys-jsdelivr-dns]')) {
      const dns = document.createElement('link');

      dns.rel = 'dns-prefetch';
      dns.href = '//cdn.jsdelivr.net';
      dns.dataset.valorysJsdelivrDns = 'true';

      document.head.appendChild(dns);
    }
  }


  /* =========================================================
     LOCALE
     ========================================================= */

  function localeBase(locale) {
    return String(locale || 'fr')
      .toLowerCase()
      .split('-')[0];
  }


  function getNameKey(locale) {
    const code = localeBase(locale);

    const supported = [
      'fr',
      'en',
      'de',
      'es',
      'pt',
      'it',
      'nl',
      'sv',
      'da',
      'fi'
    ];

    return supported.includes(code)
      ? `nom_${code}`
      : 'nom_fr';
  }


  /* =========================================================
     NORMALIZATION
     ========================================================= */

  function normalizeSearch(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '')
      .replace(/[-\s]+/g, ' ')
      .toLowerCase()
      .trim();
  }


  function clampNumber(value) {
    const clean = String(value || '')
      .replace(/\D/g, '')
      .slice(0, 3);

    if (!clean) {
      return '';
    }

    return String(
      Math.min(
        parseInt(clean, 10),
        999
      )
    ).padStart(
      clean.length,
      '0'
    );
  }


  function normalizeName(value, maxLength = 12) {
    return String(value || '')
      .toLocaleUpperCase()
      .replace(/[^\p{L}0-9 \-']/gu, '')
      .slice(0, maxLength);
  }


  /* =========================================================
     CONFIGURATION HELPERS
     ========================================================= */

  function getStorageKey(state) {
    const productId =
      state.config.productId ||
      'default';

    return `${STORAGE_PREFIX}${productId}`;
  }


  function readStoredConfiguration(state) {
    try {
      const raw =
        window.localStorage.getItem(
          getStorageKey(state)
        );

      if (!raw) return null;

      const data =
        JSON.parse(raw);

      if (
        !data ||
        data.version !== CONFIG_VERSION
      ) {
        return null;
      }

      return data;
    } catch (_) {
      return null;
    }
  }


  function getCurrentConfiguration(state) {
    return {
      version: CONFIG_VERSION,
      countryA: state.selectA.value || '',
      countryB: state.selectB.value || '',
      view: state.isBack ? 'back' : 'front',
      flocking: Boolean(state.hasFlocage.checked),
      name: state.flocName.value || '',
      number: state.flocNum.value || '',
      name2: state.flocName2.value || '',
      size: state.size.value || '',
      quantity: Math.max(
        1,
        parseInt(state.quantity.value, 10) || 1
      )
    };
  }


  function saveCurrentConfiguration(state) {
    try {
      window.localStorage.setItem(
        getStorageKey(state),
        JSON.stringify(
          getCurrentConfiguration(state)
        )
      );
    } catch (_) {
      // Le configurateur reste entièrement fonctionnel
      // même si le stockage local est indisponible.
    }
  }


  function readUrlConfiguration() {
    const params =
      new URLSearchParams(
        window.location.search
      );

    const hasValorysParams =
      VALORYS_QUERY_KEYS.some(
        (key) => params.has(key)
      );

    if (!hasValorysParams) {
      return null;
    }

    const flockingRaw =
      params.get('v_floc');

    const quantityRaw =
      params.get('v_qty');

    return {
      version: CONFIG_VERSION,
      source: params.get('v_source') || 'url',
      countryA: params.get('v_a') || '',
      countryB: params.get('v_b') || '',
      view: params.get('v_view') || 'front',
      flocking:
        flockingRaw === '1' ||
        flockingRaw === 'true' ||
        flockingRaw === 'Oui',
      name: params.get('v_name') || '',
      number: params.get('v_num') || '',
      name2: params.get('v_name2') || '',
      size: params.get('v_size') || '',
      quantity: Math.max(
        1,
        parseInt(quantityRaw, 10) || 1
      ),
      edit: {
        group: params.get('v_edit_group') || '',
        mainKey: params.get('v_edit_main') || '',
        serviceKey: params.get('v_edit_service') || ''
      }
    };
  }


  function cleanValorysQueryParams(keepEdit = false) {
    try {
      const url =
        new URL(window.location.href);

      VALORYS_QUERY_KEYS.forEach(
        (key) => {
          if (
            keepEdit &&
            key.startsWith('v_edit_')
          ) {
            return;
          }

          url.searchParams.delete(key);
        }
      );

      window.history.replaceState(
        {},
        '',
        `${url.pathname}${url.search}${url.hash}`
      );
    } catch (_) {}
  }


  function isValidCountryKey(state, key) {
    return Boolean(
      key &&
      state.data[key]?.front &&
      state.data[key]?.back &&
      state.data[key]?.flag
    );
  }


  function applyConfiguration(
    state,
    configuration
  ) {
    if (!configuration) return;

    if (
      isValidCountryKey(
        state,
        configuration.countryA
      )
    ) {
      state.selectA.value =
        configuration.countryA;
    }

    if (
      isValidCountryKey(
        state,
        configuration.countryB
      )
    ) {
      state.selectB.value =
        configuration.countryB;
    }

    state.isBack =
      configuration.view === 'back' ||
      configuration.view === 'dos';

    state.hasFlocage.checked =
      Boolean(configuration.flocking);

    toggleFlocageFields(state);

    if (state.hasFlocage.checked) {
      state.flocName.value =
        normalizeName(
          configuration.name || '',
          12
        );

      state.flocNum.value =
        clampNumber(
          configuration.number || ''
        );

      state.flocName2.value =
        normalizeName(
          configuration.name2 || '',
          12
        );
    }

    if (
      configuration.size &&
      state.config.variantsBySize?.[
        configuration.size
      ]
    ) {
      state.size.value =
        configuration.size;
    }

    state.quantity.value =
      Math.max(
        1,
        parseInt(
          configuration.quantity,
          10
        ) || 1
      );

    [
      state.selectA,
      state.selectB
    ].forEach(
      (select) => {
        if (select._valorysSearchInput) {
          select._valorysSearchInput.value = '';
          select._valorysSearchInput.classList.remove('is-exact-match');
        }
      }
    );
  }


  function clearFieldError(element) {
    if (!element) return;

    const container =
      element.closest(
        '.valorys-configurator__field, .country-wrapper'
      );

    if (!container) return;

    container.classList.remove(
      'has-error'
    );

    container
      .querySelectorAll(
        '.valorys-configurator__field-error'
      )
      .forEach((node) => node.remove());
  }


  function clearValidationErrors(state) {
    state.section
      .querySelectorAll(
        '.has-error'
      )
      .forEach(
        (node) =>
          node.classList.remove(
            'has-error'
          )
      );

    state.section
      .querySelectorAll(
        '.valorys-configurator__field-error'
      )
      .forEach(
        (node) => node.remove()
      );
  }


  function setFieldError(
    element,
    message
  ) {
    if (!element) return;

    const container =
      element.closest(
        '.valorys-configurator__field, .country-wrapper'
      );

    if (!container) return;

    container.classList.add(
      'has-error'
    );

    const error =
      document.createElement('div');

    error.className =
      'valorys-configurator__field-error';

    error.setAttribute(
      'role',
      'alert'
    );

    error.textContent = message;

    container.appendChild(error);
  }


  function focusFirstValidationError(state) {
    const first =
      state.section.querySelector(
        '.has-error'
      );

    if (!first) return;

    first.scrollIntoView({
      behavior:
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth',
      block: 'center'
    });

    window.setTimeout(
      () => {
        first
          .querySelector(
            'input:not([type="hidden"]), select, button'
          )
          ?.focus({
            preventScroll: true
          });
      },
      300
    );
  }


  function validateConfiguration(state) {
    clearValidationErrors(state);

    const i18n =
      state.config.i18n || {};

    let valid = true;

    if (
      !isValidCountryKey(
        state,
        state.selectA.value
      )
    ) {
      setFieldError(
        state.selectA,
        i18n.countryError ||
          'Choisis une première origine.'
      );

      valid = false;
    }

    if (
      !isValidCountryKey(
        state,
        state.selectB.value
      )
    ) {
      setFieldError(
        state.selectB,
        i18n.countryError ||
          'Choisis une deuxième origine.'
      );

      valid = false;
    }

    if (
      state.selectA.value &&
      state.selectA.value ===
        state.selectB.value
    ) {
      const message =
        i18n.sameOriginsError ||
        'Choisis deux origines différentes.';

      setFieldError(
        state.selectA,
        message
      );

      setFieldError(
        state.selectB,
        message
      );

      valid = false;
    }

    const variant =
      state.config.variantsBySize?.[
        state.size.value
      ];

    if (
      !variant?.id ||
      !variant.available
    ) {
      setFieldError(
        state.size,
        i18n.sizeError ||
          'Cette taille est indisponible.'
      );

      valid = false;
    }

    if (state.hasFlocage.checked) {
      normalizeFlocInputs(state);

      if (!state.flocName.value.trim()) {
        setFieldError(
          state.flocName,
          i18n.flocNameError ||
            'Ajoute un nom pour le flocage.'
        );

        valid = false;
      }

      if (!state.flocNum.value.trim()) {
        setFieldError(
          state.flocNum,
          i18n.flocNumberError ||
            'Ajoute un numéro pour le flocage.'
        );

        valid = false;
      }
    }

    if (!valid) {
      if (state.status) {
        state.status.textContent =
          i18n.validationError ||
          'Vérifie les champs indiqués.';
      }

      focusFirstValidationError(state);
    }

    return valid;
  }


  function updateHeaderCartCount(cart) {
    const count =
      (cart.items || []).reduce(
        (total, item) => {
          const role =
            item.properties?._ValorysRole;

          return role === 'flocage'
            ? total
            : total + Number(item.quantity || 0);
        },
        0
      );

    const badge =
      document.querySelector(
        '.valorys-header__cart-count'
      );

    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count <= 0;
    }
  }


  async function fetchCartState() {
    const rootUrl =
      window.Shopify?.routes?.root || '/';

    const response =
      await fetch(
        `${rootUrl}cart.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

    if (!response.ok) {
      return null;
    }

    return response.json();
  }


  async function removeEditedCreation(state) {
    const edit =
      state.editContext;

    if (
      !edit?.mainKey &&
      !edit?.serviceKey
    ) {
      return true;
    }

    const updates = {};

    if (edit.mainKey) {
      updates[edit.mainKey] = 0;
    }

    if (edit.serviceKey) {
      updates[edit.serviceKey] = 0;
    }

    const rootUrl =
      window.Shopify?.routes?.root || '/';

    const response =
      await fetch(
        `${rootUrl}cart/update.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            updates
          })
        }
      );

    if (!response.ok) {
      return false;
    }

    state.editContext = null;
    cleanValorysQueryParams(false);

    return true;
  }


  function closeSuccess(state) {
    const modal =
      state.successModal;

    if (!modal) return;

    modal.classList.remove(
      'is-open'
    );

    document.body.classList.remove(
      'valorys-success-open'
    );

    window.setTimeout(
      () => {
        modal.hidden = true;
      },
      220
    );
  }


  function showSuccess(
    state,
    warning = ''
  ) {
    const modal =
      state.successModal;

    if (!modal) {
      window.location.href =
        state.config.cartUrl || '/cart';
      return;
    }

    if (state.successPreview) {
      if (state.inputPreview.value) {
        state.successPreview.src =
          state.inputPreview.value;
        state.successPreview.hidden = false;
      } else {
        state.successPreview.hidden = true;
      }
    }

    if (state.successCombination) {
      state.successCombination.textContent =
        state.combination?.textContent?.trim() || '';
    }

    if (state.successMeta) {
      const meta = [
        state.size.value,
        state.hasFlocage.checked
          ? [
              state.flocName.value,
              state.flocNum.value
            ]
              .filter(Boolean)
              .join(' · ')
          : ''
      ]
        .filter(Boolean)
        .join(' · ');

      state.successMeta.textContent =
        meta;
    }

    if (state.successWarning) {
      state.successWarning.textContent =
        warning || '';
      state.successWarning.hidden =
        !warning;
    }

    modal.hidden = false;

    requestAnimationFrame(
      () => {
        modal.classList.add(
          'is-open'
        );
      }
    );

    document.body.classList.add(
      'valorys-success-open'
    );
  }


  function updateMobileSticky(state) {
    if (
      !state.mobileBar ||
      window.innerWidth > 749
    ) {
      state.mobileBar?.classList.remove(
        'is-visible'
      );
      return;
    }

    const sectionRect =
      state.section.getBoundingClientRect();

    const submitRect =
      state.submit.getBoundingClientRect();

    const mainSubmitVisible =
      submitRect.top < window.innerHeight &&
      submitRect.bottom > 0;

    const hasEnteredProduct =
      sectionRect.top < 0 &&
      sectionRect.bottom > 100;

    state.mobileBar.classList.toggle(
      'is-visible',
      hasEnteredProduct &&
      !mainSubmitVisible &&
      !document.body.classList.contains(
        'valorys-success-open'
      )
    );
  }


  function initMobileSticky(state) {
    if (!state.mobileBar) return;

    let ticking = false;

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(
        () => {
          updateMobileSticky(state);
          ticking = false;
        }
      );
    };

    window.addEventListener(
      'scroll',
      requestUpdate,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      requestUpdate,
      { passive: true }
    );

    state.mobileSubmit?.addEventListener(
      'click',
      () => {
        state.form.requestSubmit(
          state.submit
        );
      }
    );

    requestUpdate();
  }



  /* =========================================================
     IMAGE LOADING
     ========================================================= */

  function loadImage(url, priority = 'auto') {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.crossOrigin = 'anonymous';
      image.referrerPolicy = 'no-referrer';
      image.decoding = 'async';

      try {
        image.fetchPriority = priority;
      } catch (_) {
        // Ancien navigateur : aucune importance.
      }

      image.onload = () => {
        resolve(image);
      };

      image.onerror = () => {
        reject(
          new Error(
            `Image impossible à charger: ${url}`
          )
        );
      };

      image.src = url;
    });
  }


  function getCachedImage(url, priority = 'auto') {
    if (!url) {
      return Promise.reject(
        new Error('URL image manquante')
      );
    }

    let record = imageCache.get(url);

    if (!record) {
      record = {
        ready: false,
        promise: null
      };

      record.promise = loadImage(url, priority)
        .then((image) => {
          record.ready = true;

          return image;
        })
        .catch((error) => {
          imageCache.delete(url);

          throw error;
        });

      imageCache.set(url, record);
    }

    return record.promise;
  }


  function isImageReady(url) {
    return imageCache.get(url)?.ready === true;
  }


  /* =========================================================
     NETWORK PREFETCH
     ========================================================= */

  /*
   * Cette fonction télécharge l'image discrètement
   * dans le cache HTTP mais ne la conserve pas dans imageCache.
   *
   * Résultat :
   * - moins de mémoire consommée ;
   * - passage face/dos nettement plus rapide.
   */
  function prefetchImage(url) {
    if (!url) return;

    if (imageCache.has(url)) return;

    if (prefetchedUrls.has(url)) return;

    prefetchedUrls.add(url);

    const image = new Image();

    image.crossOrigin = 'anonymous';
    image.referrerPolicy = 'no-referrer';
    image.decoding = 'async';

    try {
      image.fetchPriority = 'low';
    } catch (_) {}

    prefetchPool.add(image);

    const cleanup = () => {
      prefetchPool.delete(image);
    };

    image.onload = cleanup;

    image.onerror = () => {
      prefetchedUrls.delete(url);

      cleanup();
    };

    image.src = url;
  }


  /* =========================================================
     MASK PATH CACHE
     ========================================================= */

  function getMaskPaths(width, height) {
    const key = `${width}x${height}`;

    if (maskPathCache.has(key)) {
      return maskPathCache.get(key);
    }

    const scaleX =
      width / SOURCE_WIDTH;

    const scaleY =
      height / SOURCE_HEIGHT;

    const scaledPoints =
      MASK_POINTS.map(
        ([x, y]) => [
          x * scaleX,
          y * scaleY
        ]
      );


    const right = new Path2D();

    right.moveTo(
      scaledPoints[0][0],
      0
    );

    scaledPoints.forEach(
      ([x, y]) => {
        right.lineTo(x, y);
      }
    );

    right.lineTo(
      width,
      height
    );

    right.lineTo(
      width,
      0
    );

    right.closePath();


    const left = new Path2D();

    left.moveTo(
      0,
      0
    );

    left.lineTo(
      scaledPoints[0][0],
      0
    );

    scaledPoints.forEach(
      ([x, y]) => {
        left.lineTo(x, y);
      }
    );

    left.lineTo(
      0,
      height
    );

    left.closePath();


    const paths = {
      left,
      right
    };

    maskPathCache.set(
      key,
      paths
    );

    return paths;
  }


  /* =========================================================
     HALF FLAG CACHE
     ========================================================= */

  function getHalfFlag(
    flag,
    flagUrl,
    useRightHalf
  ) {
    const key =
      `${flagUrl}|${useRightHalf ? 'right' : 'left'}`;

    if (halfFlagCache.has(key)) {
      return halfFlagCache.get(key);
    }

    const offscreen =
      document.createElement('canvas');

    offscreen.width =
      Math.max(
        1,
        Math.round(flag.width / 2)
      );

    offscreen.height =
      flag.height;


    const context =
      offscreen.getContext('2d');

    context.imageSmoothingEnabled =
      false;


    const sourceX =
      useRightHalf
        ? flag.width / 2
        : 0;


    context.drawImage(
      flag,

      sourceX,
      0,

      flag.width / 2,
      flag.height,

      0,
      0,

      offscreen.width,
      offscreen.height
    );


    halfFlagCache.set(
      key,
      offscreen
    );

    return offscreen;
  }


  /* =========================================================
     FLOCKING HELPERS
     ========================================================= */

  function getNameFontSize(
    length,
    basePx,
    minPx,
    reductionPx
  ) {
    if (length <= 9) {
      return basePx;
    }

    return Math.max(
      minPx,
      basePx -
        (
          (length - 9) *
          reductionPx
        )
    );
  }


  /* =========================================================
     MONEY
     ========================================================= */

  function formatMoney(
    cents,
    locale,
    currency
  ) {
    try {
      return new Intl.NumberFormat(
        locale || undefined,
        {
          style: 'currency',
          currency: currency || 'EUR'
        }
      ).format(
        (Number(cents) || 0) / 100
      );
    } catch (_) {
      return `${(
        (Number(cents) || 0) / 100
      ).toFixed(2)} €`;
    }
  }


  /* =========================================================
     MINI PREVIEW
     ========================================================= */

  function generateMiniPreview(
    canvas,
    maxSize = 220
  ) {
    const offscreen =
      document.createElement('canvas');

    const context =
      offscreen.getContext('2d');


    const ratio =
      Math.min(
        maxSize / canvas.width,
        maxSize / canvas.height
      );


    offscreen.width =
      Math.max(
        1,
        Math.round(
          canvas.width * ratio
        )
      );

    offscreen.height =
      Math.max(
        1,
        Math.round(
          canvas.height * ratio
        )
      );


    context.drawImage(
      canvas,
      0,
      0,
      offscreen.width,
      offscreen.height
    );


    return offscreen.toDataURL(
      'image/png'
    );
  }


  /* =========================================================
     FLOCKING MASK
     ========================================================= */

  function generateFlocageMask(
    state,
    maxSize = 400
  ) {
    if (!state.hasFlocage.checked) {
      return '';
    }


    const source =
      document.createElement('canvas');

    source.width = 1000;
    source.height = 1000;


    const context =
      source.getContext('2d');


    context.fillStyle = '#000';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.font =
      '90px "Redig-Regular", Arial, sans-serif';


    const name1 =
      normalizeName(
        state.flocName.value
      );

    const number =
      clampNumber(
        state.flocNum.value
      );

    const name2 =
      normalizeName(
        state.flocName2.value
      );


    if (name1) {
      context.fillText(
        name1,
        500,
        250
      );
    }

    if (number) {
      context.fillText(
        number,
        500,
        500
      );
    }

    if (name2) {
      context.fillText(
        name2,
        500,
        780
      );
    }


    const preview =
      document.createElement('canvas');


    const ratio =
      maxSize / source.width;


    preview.width =
      Math.round(
        source.width * ratio
      );

    preview.height =
      Math.round(
        source.height * ratio
      );


    preview
      .getContext('2d')
      .drawImage(
        source,
        0,
        0,
        preview.width,
        preview.height
      );


    return preview.toDataURL(
      'image/png'
    );
  }


  /* =========================================================
     STATE
     ========================================================= */

  function buildState(root) {
    const section =
      root.matches?.(
        '[data-valorys-configurator]'
      )
        ? root
        : root.querySelector?.(
            '[data-valorys-configurator]'
          );


    if (
      !section ||
      section.dataset.valorysInitialized === 'true'
    ) {
      return null;
    }


    const canvas =
      section.querySelector(
        '#maillotCanvas'
      );

    const selectA =
      section.querySelector(
        '#paysA'
      );

    const selectB =
      section.querySelector(
        '#paysB'
      );

    const form =
      section.querySelector(
        '#product-form'
      );


    if (
      !canvas ||
      !selectA ||
      !selectB ||
      !form ||
      !window.jerseyData
    ) {
      return null;
    }


    /*
     * Sécurité :
     * même si le Liquid n'a pas encore été modifié,
     * le JS force le canvas live à 1200 × 1200.
     */
    if (
      canvas.width !== LIVE_CANVAS_WIDTH ||
      canvas.height !== LIVE_CANVAS_HEIGHT
    ) {
      canvas.width =
        LIVE_CANVAS_WIDTH;

      canvas.height =
        LIVE_CANVAS_HEIGHT;
    }


    const context =
      canvas.getContext(
        '2d',
        {
          alpha: true
        }
      );


    section.dataset.valorysInitialized =
      'true';


    return {
      section,
      form,

      canvas,
      ctx: context,

      selectA,
      selectB,

      toggleView:
        section.querySelector(
          '#toggleView'
        ),

      toggleViewLabel:
        section.querySelector(
          '[data-valorys-view-label]'
        ),

      currentViewLabel:
        section.querySelector(
          '[data-valorys-current-view]'
        ),

      combination:
        section.querySelector(
          '[data-valorys-combination]'
        ),

      loader:
        section.querySelector(
          '[data-valorys-loader]'
        ),

      size:
        section.querySelector(
          '#size'
        ),

      quantity:
        section.querySelector(
          '#quantity'
        ),

      quantityMinus:
        section.querySelector(
          '[data-valorys-quantity-minus]'
        ),

      quantityPlus:
        section.querySelector(
          '[data-valorys-quantity-plus]'
        ),

      hasFlocage:
        section.querySelector(
          '#hasFlocage'
        ),

      flocName:
        section.querySelector(
          '#flocName'
        ),

      flocNum:
        section.querySelector(
          '#flocNum'
        ),

      flocName2:
        section.querySelector(
          '#flocName2'
        ),

      variantId:
        section.querySelector(
          '#variant-id'
        ),

      inputPaysA:
        section.querySelector(
          '#input-paysA'
        ),

      inputPaysB:
        section.querySelector(
          '#input-paysB'
        ),

      inputView:
        section.querySelector(
          '#input-view'
        ),

      inputFlocage:
        section.querySelector(
          '#input-flocage'
        ),

      inputFlocName:
        section.querySelector(
          '#input-floc-name'
        ),

      inputFlocNum:
        section.querySelector(
          '#input-floc-num'
        ),

      inputFlocName2:
        section.querySelector(
          '#input-floc-name2'
        ),

      inputPreview:
        section.querySelector(
          '#input-preview'
        ),

      inputFlocMask:
        section.querySelector(
          '#input-flocmask'
        ),

      price:
        section.querySelector(
          '[data-valorys-price]'
        ),

      total:
        section.querySelector(
          '[data-valorys-total]'
        ),

      submit:
        section.querySelector(
          '[data-valorys-submit]'
        ),

      submitLabel:
        section.querySelector(
          '[data-valorys-submit-label]'
        ),

      status:
        section.querySelector(
          '[data-valorys-status]'
        ),

      mobileBar:
        section.querySelector(
          '[data-valorys-mobile-bar]'
        ),

      mobileTotal:
        section.querySelector(
          '[data-valorys-mobile-total]'
        ),

      mobileSubmit:
        section.querySelector(
          '[data-valorys-mobile-submit]'
        ),

      mobileSubmitLabel:
        section.querySelector(
          '[data-valorys-mobile-submit-label]'
        ),

      successModal:
        section.querySelector(
          '[data-valorys-success]'
        ),

      successPreview:
        section.querySelector(
          '[data-valorys-success-preview]'
        ),

      successCombination:
        section.querySelector(
          '[data-valorys-success-combination]'
        ),

      successMeta:
        section.querySelector(
          '[data-valorys-success-meta]'
        ),

      successWarning:
        section.querySelector(
          '[data-valorys-success-warning]'
        ),

      editContext: null,

      isBack: false,

      renderId: 0,

      lastRenderSignature: '',

      flockingRenderTimer: null,

      warmHandle: null,

      locale:
        window.MaillotConfig?.locale ||
        document.documentElement.lang ||
        'fr',

      nameKey:
        getNameKey(
          window.MaillotConfig?.locale ||
          document.documentElement.lang ||
          'fr'
        ),

      data:
        window.jerseyData || {},

      groups:
        window.countryGroups || {},

      config:
        window.MaillotConfig || {}
    };
  }


  /* =========================================================
     COUNTRY DATA
     ========================================================= */

  function validJerseyKeys(state) {
    return Object.keys(
      state.data
    ).filter(
      (key) => {
        const item =
          state.data[key];

        return (
          item &&
          item.front &&
          item.back &&
          item.flag
        );
      }
    );
  }


  function getDisplayName(
    state,
    key
  ) {
    return (
      state.data[key]?.[state.nameKey] ||
      state.data[key]?.nom_fr ||
      key
    );
  }


  /* =========================================================
     COUNTRY SELECTS
     ========================================================= */

  function populateCountrySelects(state) {
    const keys =
      validJerseyKeys(state);

    const validSet =
      new Set(keys);


    const children =
      new Set(
        Object.values(
          state.groups
        )
          .flat()
          .filter(
            (key) =>
              validSet.has(key)
          )
      );


    const parents =
      keys
        .filter(
          (key) =>
            !children.has(key)
        )
        .sort(
          (a, b) =>
            getDisplayName(
              state,
              a
            ).localeCompare(
              getDisplayName(
                state,
                b
              ),
              state.locale
            )
        );


    const addOption =
      (
        select,
        key,
        child,
        parentKey = ''
      ) => {

        const option =
          new Option(
            child
              ? `↳ ${getDisplayName(state, key)}`
              : getDisplayName(state, key),

            key
          );


        if (child) {
          option.dataset.child = '1';
          option.dataset.parent = parentKey;
        }


        select.add(option);
      };


    state.selectA.innerHTML =
      '';

    state.selectB.innerHTML =
      '';


    parents.forEach(
      (key) => {

        addOption(
          state.selectA,
          key,
          false
        );

        addOption(
          state.selectB,
          key,
          false
        );


        (
          state.groups[key] ||
          []
        ).forEach(
          (childKey) => {

            if (
              !validSet.has(
                childKey
              )
            ) {
              return;
            }


            addOption(
              state.selectA,
              childKey,
              true,
              key
            );

            addOption(
              state.selectB,
              childKey,
              true,
              key
            );
          }
        );
      }
    );


    const defaultA =
      validSet.has('france')
        ? 'france'
        : keys[0];


    const defaultB =
      validSet.has('senegal')
        ? 'senegal'
        : keys.find(
            (key) =>
              key !== defaultA
          );


    state.selectA.value =
      defaultA || '';

    state.selectB.value =
      defaultB ||
      defaultA ||
      '';
  }


  /* =========================================================
     AUTOCOMPLETE
     ========================================================= */

  function attachAutocomplete(state, select) {
    const wrapper = select.closest('.select-with-search');
    if (!wrapper || wrapper.querySelector('.country-search')) return;

    const messages = {
      fr: ['Voir tous les pays', 'Masquer la liste', 'Aucun pays trouvé'],
      en: ['View all countries', 'Hide country list', 'No countries found'],
      de: ['Alle Länder anzeigen', 'Liste schließen', 'Keine Länder gefunden'],
      es: ['Ver todos los países', 'Ocultar lista', 'No se encontraron países'],
      it: ['Mostra tutti i paesi', 'Nascondi elenco', 'Nessun paese trovato'],
      pt: ['Ver todos os países', 'Ocultar lista', 'Nenhum país encontrado'],
      nl: ['Alle landen bekijken', 'Lijst verbergen', 'Geen landen gevonden'],
      sv: ['Visa alla länder', 'Dölj listan', 'Inga länder hittades'],
      da: ['Vis alle lande', 'Skjul listen', 'Ingen lande fundet'],
      fi: ['Näytä kaikki maat', 'Piilota luettelo', 'Maita ei löytynyt']
    };
    const [showLabel, hideLabel, emptyLabel] =
      messages[localeBase(state.locale)] || messages.fr;

    const input = document.createElement('input');
    input.type = 'search';
    input.className = 'country-search';
    input.placeholder = state.config.i18n?.search || 'Rechercher...';
    input.autocomplete = 'off';
    input.setAttribute('aria-label', input.placeholder);

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'country-list-toggle';
    toggle.textContent = showLabel;
    toggle.setAttribute('aria-expanded', 'false');

    const results = document.createElement('div');
    results.className = 'autocomplete-results';
    results.id = `${select.id}-country-options`;
    results.setAttribute('aria-label', showLabel);
    toggle.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-controls', results.id);

    wrapper.insertBefore(input, select);
    wrapper.insertBefore(toggle, select);
    wrapper.insertBefore(results, select);

    let isListOpen = false;

    function closeResults() {
      isListOpen = false;
      results.replaceChildren();
      toggle.textContent = showLabel;
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function chooseOption(option) {
      select.value = option.value;
      input.value = '';
      input.classList.remove('is-exact-match');
      closeResults();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function displayOptions(options) {
      const fragment = document.createDocumentFragment();
      if (!options.length) {
        const empty = document.createElement('p');
        empty.className = 'country-list-empty';
        empty.textContent = emptyLabel;
        fragment.appendChild(empty);
      }
      options.forEach((option) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'autocomplete-item';

        const isRegion = option.dataset.child === '1';
        const name = getDisplayName(state, option.value);

        if (isRegion) {
          item.classList.add('is-region');

          const arrow = document.createElement('span');
          arrow.className = 'country-region-arrow';
          arrow.textContent = '↳';
          arrow.setAttribute('aria-hidden', 'true');
          item.appendChild(arrow);
        }

        const label = document.createElement('span');
        label.className = 'country-option-name';
        label.textContent = name;
        item.appendChild(label);

        if (isRegion && option.dataset.parent) {
          const parentName = getDisplayName(state, option.dataset.parent);
          const parent = document.createElement('span');
          parent.className = 'country-option-parent';
          parent.textContent = parentName;
          parent.setAttribute('aria-hidden', 'true');
          item.appendChild(parent);
          item.setAttribute('aria-label', `${name} — ${parentName}`);
        }

        if (option.value === select.value) {
          item.classList.add('is-selected');
          item.setAttribute('aria-current', 'true');
        }
        item.addEventListener('click', () => chooseOption(option));
        fragment.appendChild(item);
      });
      results.replaceChildren(fragment);
      results.scrollTop = 0;
    }

    toggle.addEventListener('click', () => {
      if (isListOpen) {
        closeResults();
        return;
      }
      input.value = '';
      input.classList.remove('is-exact-match');
      isListOpen = true;
      toggle.textContent = hideLabel;
      toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      displayOptions([...select.options]);
    });

    input.addEventListener('input', () => {
      const query = normalizeSearch(input.value);
      input.classList.remove('is-exact-match');
      closeResults();
      if (!query) return;

      // Un nom complet (maj./accents/espaces ignores) selectionne le pays
      // immediatement. Les recherches partielles restent des suggestions.
      // En cas de noms identiques, on evite une selection ambigue.
      const exactMatches = [...select.options].filter((option) =>
        normalizeSearch(getDisplayName(state, option.value)) === query
      );
      if (exactMatches.length === 1) {
        const exactOption = exactMatches[0];
        if (select.value !== exactOption.value) {
          select.value = exactOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        input.classList.add('is-exact-match');
        return;
      }

      const matches = [...select.options].filter((option) =>
        normalizeSearch(getDisplayName(state, option.value)).includes(query) ||
        normalizeSearch(option.value).includes(query)
      );
      displayOptions(matches.slice(0, 16));
    });

    input.addEventListener('focus', () => {
      if (input.value) input.dispatchEvent(new Event('input'));
    });

    wrapper.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeResults();
        toggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeResults();
    });

    select._valorysSearchInput = input;
  }


  /* =========================================================
     COMBINATION LABEL
     ========================================================= */

  function updateCombination(state) {
    if (
      !state.combination
    ) {
      return;
    }


    state.combination.textContent =
      `${getDisplayName(
        state,
        state.selectA.value
      )} × ${getDisplayName(
        state,
        state.selectB.value
      )}`;
  }


  /* =========================================================
     FLOCKING FORM
     ========================================================= */

  function toggleFlocageFields(state) {
    const enabled =
      state.hasFlocage.checked;


    [
      state.flocName,
      state.flocNum,
      state.flocName2
    ].forEach(
      (input) => {

        if (input) {
          input.disabled =
            !enabled;
        }
      }
    );


    if (!enabled) {
      state.flocName.value =
        '';

      state.flocNum.value =
        '';

      state.flocName2.value =
        '';
    }
  }


  function normalizeFlocInputs(state) {
    state.flocName.value =
      normalizeName(
        state.flocName.value,
        12
      );

    state.flocName2.value =
      normalizeName(
        state.flocName2.value,
        12
      );

    state.flocNum.value =
      clampNumber(
        state.flocNum.value
      );
  }


  /* =========================================================
     SHOPIFY PROPERTIES
     ========================================================= */

  function syncProperties(state) {
    normalizeFlocInputs(state);


    state.inputPaysA.value =
      state.selectA.value;

    state.inputPaysB.value =
      state.selectB.value;

    state.inputView.value =
      state.isBack
        ? 'dos'
        : 'face';

    state.inputFlocage.value =
      state.hasFlocage.checked
        ? 'Oui'
        : 'Non';


    if (
      state.hasFlocage.checked
    ) {
      state.inputFlocName.value =
        state.flocName.value;

      state.inputFlocNum.value =
        state.flocNum.value;

      state.inputFlocName2.value =
        state.flocName2.value;
    } else {
      state.inputFlocName.value =
        '';

      state.inputFlocNum.value =
        '';

      state.inputFlocName2.value =
        '';
    }


    updateCombination(state);
  }


  /* =========================================================
     REDIG FONT
     ========================================================= */

  function ensureRedigLoaded() {
    if (
      !document.fonts?.load
    ) {
      return Promise.resolve();
    }


    if (!redigPromise) {
      redigPromise =
        document.fonts
          .load(
            '400 200px "Redig-Regular"'
          )
          .catch(
            () => []
          );
    }


    return redigPromise;
  }


  /* =========================================================
     DRAW FLOCKING
     ========================================================= */

  async function drawFlocageOnBack(
    state,
    requestId
  ) {
    if (
      !state.hasFlocage.checked
    ) {
      return true;
    }


    normalizeFlocInputs(state);


    const name1 =
      state.flocName.value;

    const number =
      state.flocNum.value;

    const name2 =
      state.flocName2.value;


    /*
     * S'il n'y a aucun texte,
     * inutile d'attendre Redig.
     */
    if (
      !name1 &&
      !number &&
      !name2
    ) {
      return true;
    }


    await ensureRedigLoaded();


    /*
     * Pendant le chargement de la police,
     * l'utilisateur a peut-être déjà changé de pays.
     */
    if (
      requestId !==
      state.renderId
    ) {
      return false;
    }


    const {
      ctx,
      canvas
    } = state;


    const width =
      canvas.width;

    const height =
      canvas.height;


    /*
     * Tout était historiquement calibré
     * pour 3000px.
     */
    const scale =
      width /
      SOURCE_WIDTH;


    const centerX =
      width * 0.5;

    const nameY =
      height * 0.15;

    const numberY =
      height * 0.40;


    const nameSize =
      getNameFontSize(
        Math.max(
          name1.length,
          name2.length
        ),

        330 * scale,
        140 * scale,
        18 * scale
      );


    const numberSize =
      1140 * scale;


    const family =
      '"Redig-Regular", Arial, sans-serif';


    ctx.save();

    ctx.textAlign =
      'center';

    ctx.textBaseline =
      'middle';

    ctx.lineJoin =
      'round';


    function drawOutlinedText(
      text,
      x,
      y,
      fontSize,
      lineWidth
    ) {
      if (!text) {
        return;
      }


      ctx.font =
        `${fontSize}px ${family}`;

      ctx.lineWidth =
        Math.max(
          1,
          lineWidth
        );

      ctx.strokeStyle =
        'rgba(0,0,0,.88)';

      ctx.fillStyle =
        '#fff';


      ctx.strokeText(
        text,
        x,
        y
      );

      ctx.fillText(
        text,
        x,
        y
      );
    }


    drawOutlinedText(
      name1,
      centerX,
      nameY,
      nameSize,
      12 * scale
    );


    if (number) {
      ctx.font =
        `${numberSize}px ${family}`;

      ctx.lineWidth =
        Math.max(
          1,
          12 * scale
        );

      ctx.strokeStyle =
        'rgba(0,0,0,.9)';

      ctx.fillStyle =
        '#fff';


      const spacing =
        50 * scale;


      const chars =
        number.split('');


      const totalWidth =
        chars.reduce(
          (sum, char) =>
            sum +
            ctx.measureText(
              char
            ).width,

          0
        ) +
        (
          spacing *
          Math.max(
            0,
            chars.length - 1
          )
        );


      let startX =
        centerX -
        totalWidth / 2;


      chars.forEach(
        (char) => {

          const charWidth =
            ctx.measureText(
              char
            ).width;


          const x =
            startX +
            charWidth / 2;


          ctx.strokeText(
            char,
            x,
            numberY
          );

          ctx.fillText(
            char,
            x,
            numberY
          );


          startX +=
            charWidth +
            spacing;
        }
      );
    }


    if (name2) {
      const gapNameToNumber =
        numberY -
        nameY;


      /* Le second flocage est volontairement légèrement plus bas
       * pour mieux équilibrer le dos du maillot. */
      const secondNameY =
        numberY +
        gapNameToNumber +
        height * 0.03;


      drawOutlinedText(
        name2,
        centerX,
        secondNameY,
        nameSize,
        10 * scale
      );
    }


    ctx.restore();

    return true;
  }


  /* =========================================================
     RENDER SIGNATURE
     ========================================================= */

  /*
   * Évite de recalculer exactement le même canvas.
   */
  function getRenderSignature(state) {
    let signature =
      [
        state.selectA.value,
        state.selectB.value,
        state.isBack
          ? 'back'
          : 'front',
        `${state.canvas.width}x${state.canvas.height}`
      ].join('|');


    /*
     * Le flocage n'a aucun impact sur la face.
     */
    if (
      state.isBack
    ) {
      signature +=
        `|${state.hasFlocage.checked ? '1' : '0'}`;

      signature +=
        `|${state.flocName.value}`;

      signature +=
        `|${state.flocNum.value}`;

      signature +=
        `|${state.flocName2.value}`;
    }


    return signature;
  }


  /* =========================================================
     MAIN CANVAS RENDER
     ========================================================= */

  async function updateCanvas(
    state,
    force = false
  ) {
    const signature =
      getRenderSignature(
        state
      );


    if (
      !force &&
      signature ===
        state.lastRenderSignature
    ) {
      return true;
    }


    const requestId =
      ++state.renderId;


    try {
      const sourceA =
        state.isBack
          ? state.selectB.value
          : state.selectA.value;


      const sourceB =
        state.isBack
          ? state.selectA.value
          : state.selectB.value;


      const entryA =
        state.data[sourceA];

      const entryB =
        state.data[sourceB];


      const viewKey =
        state.isBack
          ? 'back'
          : 'front';


      if (
        !entryA?.[viewKey] ||
        !entryB?.[viewKey]
      ) {
        throw new Error(
          'Une des créations sélectionnées est incomplète.'
        );
      }


      /*
       * Le dos n'a PAS besoin des drapeaux.
       */
      const neededUrls = [
        entryA[viewKey],
        entryB[viewKey]
      ];


      if (!state.isBack) {
        if (entryA.flag) {
          neededUrls.push(
            entryA.flag
          );
        }

        if (entryB.flag) {
          neededUrls.push(
            entryB.flag
          );
        }
      }


      /*
       * Pas de flash du loader
       * lorsque tout est déjà décodé.
       */
      const needsLoading =
        neededUrls.some(
          (url) =>
            !isImageReady(url)
        );


      if (state.loader) {
        state.loader.hidden =
          !needsLoading;
      }


      /*
       * Priorité HIGH uniquement aux images
       * réellement affichées maintenant.
       */
      const jerseyPromise =
        Promise.all([
          getCachedImage(
            entryA[viewKey],
            'high'
          ),

          getCachedImage(
            entryB[viewKey],
            'high'
          )
        ]);


      let flagPromise =
        Promise.resolve([
          null,
          null
        ]);


      if (!state.isBack) {
        flagPromise =
          Promise.all([
            getCachedImage(
              entryA.flag,
              'high'
            ),

            getCachedImage(
              entryB.flag,
              'high'
            )
          ]);
      }


      const [
        jerseys,
        flags
      ] =
        await Promise.all([
          jerseyPromise,
          flagPromise
        ]);


      if (
        requestId !==
        state.renderId
      ) {
        return false;
      }


      const [
        imageA,
        imageB
      ] =
        jerseys;


      const [
        flagA,
        flagB
      ] =
        flags;


      const {
        ctx,
        canvas
      } = state;


      ctx.imageSmoothingEnabled =
        false;


      ctx.clearRect(
        0,
        0,
        canvas.width,
        canvas.height
      );


      const paths =
        getMaskPaths(
          canvas.width,
          canvas.height
        );


      /* =========================
         LEFT HALF
         ========================= */

      ctx.save();

      ctx.clip(
        paths.left
      );

      ctx.drawImage(
        imageA,

        0,
        0,
        imageA.width,
        imageA.height,

        0,
        0,
        canvas.width,
        canvas.height
      );

      ctx.restore();


      /* =========================
         RIGHT HALF
         ========================= */

      ctx.save();

      ctx.clip(
        paths.right
      );

      ctx.drawImage(
        imageB,

        0,
        0,
        imageB.width,
        imageB.height,

        0,
        0,
        canvas.width,
        canvas.height
      );

      ctx.restore();


      /* =========================
         FRONT FLAGS
         ========================= */

      if (!state.isBack) {
        const scale =
          canvas.width /
          SOURCE_WIDTH;


        const logoSize =
          240 * scale;


        const logoY =
          (
            canvas.height *
            0.22
          ) -
          (
            40 * scale
          );


        const logoX =
          canvas.width *
          0.60;


        const halfA =
          getHalfFlag(
            flagA,
            entryA.flag,
            false
          );


        const halfB =
          getHalfFlag(
            flagB,
            entryB.flag,
            true
          );


        ctx.drawImage(
          halfA,
          logoX,
          logoY,
          logoSize / 2,
          logoSize
        );


        ctx.drawImage(
          halfB,
          logoX +
            logoSize / 2,
          logoY,
          logoSize / 2,
          logoSize
        );
      }

      /* =========================
         BACK FLOCKING
         ========================= */

      else {
        const flocageDrawn =
          await drawFlocageOnBack(
            state,
            requestId
          );


        if (!flocageDrawn) {
          return false;
        }
      }


      if (
        requestId !==
        state.renderId
      ) {
        return false;
      }


      state.lastRenderSignature =
        signature;


      return true;

    } catch (error) {
      console.error(
        '[The Valorys] Rendu configurateur:',
        error
      );


      if (
        requestId ===
          state.renderId &&
        state.status
      ) {
        state.status.textContent =
          state.config.i18n
            ?.genericError ||
          'Une erreur est survenue.';
      }


      return false;

    } finally {
      if (
        requestId ===
          state.renderId &&
        state.loader
      ) {
        state.loader.hidden =
          true;
      }
    }
  }


  /* =========================================================
     OPPOSITE VIEW PREFETCH
     ========================================================= */

  function warmOppositeView(state) {
    const entryA =
      state.data[
        state.selectA.value
      ];

    const entryB =
      state.data[
        state.selectB.value
      ];


    if (
      !entryA ||
      !entryB
    ) {
      return;
    }


    /*
     * FACE affichée :
     * on précharge seulement les 2 dos.
     */
    if (!state.isBack) {
      prefetchImage(
        entryA.back
      );

      prefetchImage(
        entryB.back
      );

      return;
    }


    /*
     * DOS affiché :
     * on précharge la face + les drapeaux.
     */
    prefetchImage(
      entryA.front
    );

    prefetchImage(
      entryB.front
    );

    prefetchImage(
      entryA.flag
    );

    prefetchImage(
      entryB.flag
    );
  }


  function cancelWarmSchedule(state) {
    if (
      !state.warmHandle
    ) {
      return;
    }


    if (
      state.warmHandle.type ===
        'idle' &&
      'cancelIdleCallback' in window
    ) {
      window.cancelIdleCallback(
        state.warmHandle.id
      );
    } else {
      window.clearTimeout(
        state.warmHandle.id
      );
    }


    state.warmHandle =
      null;
  }


  function scheduleWarmOppositeView(state) {
    cancelWarmSchedule(
      state
    );


    const run = () => {
      state.warmHandle =
        null;

      warmOppositeView(
        state
      );
    };


    if (
      'requestIdleCallback' in
      window
    ) {
      state.warmHandle = {
        type: 'idle',

        id:
          window.requestIdleCallback(
            run,
            {
              timeout: 1000
            }
          )
      };

      return;
    }


    state.warmHandle = {
      type: 'timeout',

      id:
        window.setTimeout(
          run,
          200
        )
    };
  }


  /* =========================================================
     VIEW UI
     ========================================================= */

  function updateViewUI(state) {
    const i18n =
      state.config.i18n || {};

    const currentLabel =
      state.isBack
        ? (i18n.back || 'Dos')
        : (i18n.face || 'Face');

    if (state.toggleViewLabel) {
      state.toggleViewLabel.textContent =
        state.isBack
          ? (i18n.seeFront || 'Voir la face')
          : (i18n.seeBack || 'Voir le dos');
    }

    if (state.currentViewLabel) {
      state.currentViewLabel.textContent =
        currentLabel;
    }

    state.section.dataset.view =
      state.isBack ? 'back' : 'front';

    const stage =
      state.section.querySelector(
        '[data-valorys-canvas-stage]'
      );

    if (stage) {
      stage.dataset.viewLabel =
        currentLabel;
    }
  }


  /* =========================================================
     VARIANT / PRICE
     ========================================================= */

  function updateVariantAndPrice(state) {
    const size =
      state.size.value;


    const variant =
      state.config
        .variantsBySize?.[
          size
        ];


    const quantity =
      Math.max(
        1,
        parseInt(
          state.quantity.value,
          10
        ) || 1
      );


    state.quantity.value =
      quantity;


    if (!variant) {
      state.variantId.value =
        '';

      state.submit.disabled =
        true;

      state.submitLabel.textContent =
        state.config.i18n
          ?.unavailable ||
        'Indisponible';

      if (state.mobileSubmit) {
        state.mobileSubmit.disabled = true;
      }

      if (state.mobileSubmitLabel) {
        state.mobileSubmitLabel.textContent =
          state.submitLabel.textContent;
      }

      return;
    }


    state.variantId.value =
      variant.id;


    state.price.textContent =
      variant.priceFormatted ||
      formatMoney(
        variant.price,
        state.locale,
        state.config.currency
      );


    const unitTotal =
      Number(
        variant.price ||
        0
      ) +
      (
        state.hasFlocage.checked
          ? Number(
              state.config
                .flocagePrice ||
              0
            )
          : 0
      );


    state.total.textContent =
      formatMoney(
        unitTotal *
          quantity,

        state.locale,

        state.config.currency
      );


    state.submit.disabled =
      !variant.available;


    state.submitLabel.textContent =
      variant.available
        ? (
            state.config.i18n
              ?.addToCart ||
            'Ajouter au panier'
          )
        : (
            state.config.i18n
              ?.unavailable ||
            'Indisponible'
          );

    if (state.mobileTotal) {
      state.mobileTotal.textContent =
        state.total.textContent;
    }

    if (state.mobileSubmit) {
      state.mobileSubmit.disabled =
        !variant.available;
    }

    if (state.mobileSubmitLabel) {
      state.mobileSubmitLabel.textContent =
        state.submitLabel.textContent;
    }
  }


  /* =========================================================
     PROPERTIES
     ========================================================= */

  function getNonEmptyProperties(state) {
    const values = {
      'Pays A':
        state.inputPaysA.value,

      'Pays B':
        state.inputPaysB.value,

      'Vue':
        state.inputView.value,

      'Flocage':
        state.inputFlocage.value,

      'Nom':
        state.inputFlocName.value,

      'Numéro':
        state.inputFlocNum.value,

      'Nom 2':
        state.inputFlocName2.value,

      '_Preview':
        state.inputPreview.value,

      '_FlocageMask':
        state.inputFlocMask.value
    };


    return Object.fromEntries(
      Object.entries(
        values
      ).filter(
        (
          [
            ,
            value
          ]
        ) =>
          String(
            value ||
            ''
          ).trim() !==
          ''
      )
    );
  }


  /* =========================================================
     CART
     ========================================================= */

  async function handleSubmit(
    state,
    event
  ) {
    event.preventDefault();

    if (
      state.submit.classList.contains(
        'is-loading'
      )
    ) {
      return;
    }

    if (state.flockingRenderTimer) {
      clearTimeout(
        state.flockingRenderTimer
      );

      state.flockingRenderTimer = null;
    }

    if (state.status) {
      state.status.textContent = '';
    }

    syncProperties(state);
    updateVariantAndPrice(state);

    if (!validateConfiguration(state)) {
      return;
    }

    const size = state.size.value;
    const variant =
      state.config.variantsBySize?.[size];

    const quantity =
      Math.max(
        1,
        parseInt(
          state.quantity.value,
          10
        ) || 1
      );

    state.submit.classList.add(
      'is-loading'
    );

    state.submit.disabled = true;

    if (state.mobileSubmit) {
      state.mobileSubmit.disabled = true;
    }

    state.submitLabel.textContent =
      state.config.i18n?.adding ||
      'Ajout en cours...';

    if (state.mobileSubmitLabel) {
      state.mobileSubmitLabel.textContent =
        state.submitLabel.textContent;
    }

    let addSucceeded = false;

    try {
      const rendered =
        await updateCanvas(state);

      if (!rendered) {
        throw new Error(
          state.config.i18n?.genericError ||
          'Impossible de générer le maillot.'
        );
      }

      syncProperties(state);

      try {
        state.inputPreview.value =
          generateMiniPreview(
            state.canvas,
            220
          );
      } catch (error) {
        console.warn(
          '[The Valorys] Mini-preview non générée:',
          error
        );

        state.inputPreview.value = '';
      }

      try {
        state.inputFlocMask.value =
          generateFlocageMask(
            state,
            400
          );
      } catch (error) {
        console.warn(
          '[The Valorys] Masque flocage non généré:',
          error
        );

        state.inputFlocMask.value = '';
      }

      const properties =
        getNonEmptyProperties(state);

      const valorysGroup =
        `valorys-${Date.now()}-${Math.random()
          .toString(36)
          .slice(2, 9)}`;

      properties._ValorysGroup =
        valorysGroup;

      properties._ValorysRole =
        'jersey';

      properties._ValorysCombination =
        state.combination?.textContent?.trim() ||
        `${getDisplayName(
          state,
          state.selectA.value
        )} × ${getDisplayName(
          state,
          state.selectB.value
        )}`;

      const items = [
        {
          id: Number(variant.id),
          quantity,
          properties
        }
      ];

      if (state.hasFlocage.checked) {
        const flocageVariantId =
          Number(
            state.config.flocageVariantId ||
            state.section
              .querySelector(
                '#flocage-variant-id'
              )
              ?.value
          );

        if (!flocageVariantId) {
          throw new Error(
            'Variante du service de flocage introuvable.'
          );
        }

        const flocageProperties = {
          _ValorysGroup: valorysGroup,
          _ValorysRole: 'flocage'
        };

        if (state.inputFlocName.value) {
          flocageProperties.Nom =
            state.inputFlocName.value;
        }

        if (state.inputFlocNum.value) {
          flocageProperties['Numéro'] =
            state.inputFlocNum.value;
        }

        if (state.inputFlocName2.value) {
          flocageProperties['Nom 2'] =
            state.inputFlocName2.value;
        }

        items.push({
          id: flocageVariantId,
          quantity,
          properties: flocageProperties
        });
      }

      const rootUrl =
        window.Shopify?.routes?.root || '/';

      const response =
        await fetch(
          `${rootUrl}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items
            })
          }
        );

      const payload =
        await response.json();

      if (!response.ok) {
        throw new Error(
          payload?.description ||
          payload?.message ||
          state.config.i18n?.genericError ||
          'Impossible d’ajouter le produit au panier.'
        );
      }

      addSucceeded = true;

      let editWarning = '';

      if (state.editContext) {
        const removed =
          await removeEditedCreation(state);

        if (!removed) {
          editWarning =
            state.config.i18n?.editCleanupError ||
            'La nouvelle création a été ajoutée, mais l’ancienne n’a pas pu être retirée automatiquement. Vérifie ton panier.';
        }
      } else {
        cleanValorysQueryParams(false);
      }

      const cart =
        await fetchCartState();

      if (cart) {
        updateHeaderCartCount(cart);
      }

      saveCurrentConfiguration(state);

      showSuccess(
        state,
        editWarning
      );

      state.submit.classList.remove(
        'is-loading'
      );

      updateVariantAndPrice(state);
      updateMobileSticky(state);

    } catch (error) {
      console.error(
        '[The Valorys] Ajout panier:',
        error
      );

      if (addSucceeded) {
        showSuccess(
          state,
          state.config.i18n?.editCleanupError ||
          'La création a été ajoutée. Vérifie ton panier avant de continuer.'
        );
      } else if (state.status) {
        state.status.textContent =
          error.message ||
          state.config.i18n?.genericError ||
          'Une erreur est survenue.';
      }

      state.submit.classList.remove(
        'is-loading'
      );

      updateVariantAndPrice(state);
      updateMobileSticky(state);
    }
  }


  /* =========================================================
     FLOCKING RENDER DEBOUNCE
     ========================================================= */

  function scheduleFlocageRender(state) {
    if (
      state.flockingRenderTimer
    ) {
      clearTimeout(
        state.flockingRenderTimer
      );
    }


    state.flockingRenderTimer =
      window.setTimeout(
        () => {
          state.flockingRenderTimer =
            null;


          if (
            state.isBack
          ) {
            updateCanvas(
              state
            );
          }
        },

        100
      );
  }


  /* =========================================================
     EVENTS
     ========================================================= */

  function bindEvents(state) {

    state.selectA.addEventListener(
      'change',
      async () => {
        clearFieldError(state.selectA);
        syncProperties(state);
        saveCurrentConfiguration(state);
        await updateCanvas(state);
        scheduleWarmOppositeView(state);
      }
    );

    state.selectB.addEventListener(
      'change',
      async () => {
        clearFieldError(state.selectB);
        syncProperties(state);
        saveCurrentConfiguration(state);
        await updateCanvas(state);
        scheduleWarmOppositeView(state);
      }
    );

    state.section
      .querySelector('#swapCountries')
      ?.addEventListener(
        'click',
        async () => {
          const currentA =
            state.selectA.value;

          state.selectA.value =
            state.selectB.value;

          state.selectB.value =
            currentA;

          [state.selectA, state.selectB]
            .forEach(
              (select) => {
                if (select._valorysSearchInput) {
                  select._valorysSearchInput.value = '';
                  select._valorysSearchInput.classList.remove('is-exact-match');
                }

                clearFieldError(select);
              }
            );

          syncProperties(state);
          saveCurrentConfiguration(state);

          await updateCanvas(state);
          scheduleWarmOppositeView(state);
        }
      );

    state.toggleView.addEventListener(
      'click',
      async () => {
        if (
          state.toggleView.classList.contains(
            'is-switching'
          )
        ) {
          return;
        }

        state.toggleView.classList.add(
          'is-switching'
        );

        state.canvas.classList.remove(
          'is-view-switching'
        );

        void state.canvas.offsetWidth;

        state.canvas.classList.add(
          'is-view-switching'
        );

        state.isBack =
          !state.isBack;

        updateViewUI(state);
        syncProperties(state);
        saveCurrentConfiguration(state);

        await updateCanvas(
          state,
          true
        );

        scheduleWarmOppositeView(state);

        window.setTimeout(
          () => {
            state.toggleView.classList.remove(
              'is-switching'
            );

            state.canvas.classList.remove(
              'is-view-switching'
            );
          },
          320
        );
      }
    );

    state.hasFlocage.addEventListener(
      'change',
      async () => {
        toggleFlocageFields(state);
        clearFieldError(state.flocName);
        clearFieldError(state.flocNum);
        syncProperties(state);
        updateVariantAndPrice(state);
        saveCurrentConfiguration(state);

        if (state.isBack) {
          await updateCanvas(state);
        }
      }
    );

    [
      state.flocName,
      state.flocNum,
      state.flocName2
    ].forEach(
      (input) => {
        input.addEventListener(
          'input',
          () => {
            clearFieldError(input);
            normalizeFlocInputs(state);
            syncProperties(state);
            saveCurrentConfiguration(state);

            if (state.isBack) {
              scheduleFlocageRender(state);
            }
          }
        );
      }
    );

    state.size.addEventListener(
      'change',
      () => {
        clearFieldError(state.size);
        updateVariantAndPrice(state);
        saveCurrentConfiguration(state);
      }
    );

    const updateQuantity = () => {
      updateVariantAndPrice(state);
      saveCurrentConfiguration(state);
    };

    state.quantity.addEventListener(
      'change',
      updateQuantity
    );

    state.quantity.addEventListener(
      'input',
      updateQuantity
    );

    state.quantityMinus?.addEventListener(
      'click',
      () => {
        state.quantity.value =
          Math.max(
            1,
            (
              parseInt(
                state.quantity.value,
                10
              ) || 1
            ) - 1
          );

        updateQuantity();
      }
    );

    state.quantityPlus?.addEventListener(
      'click',
      () => {
        state.quantity.value =
          Math.max(
            1,
            (
              parseInt(
                state.quantity.value,
                10
              ) || 1
            ) + 1
          );

        updateQuantity();
      }
    );

    state.form.addEventListener(
      'submit',
      (event) =>
        handleSubmit(
          state,
          event
        )
    );

    state.section
      .querySelectorAll(
        '[data-valorys-success-close]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              closeSuccess(state);
              updateMobileSticky(state);
            }
          );
        }
      );

    state.successModal?.addEventListener(
      'click',
      (event) => {
        if (
          event.target === state.successModal
        ) {
          closeSuccess(state);
          updateMobileSticky(state);
        }
      }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          state.successModal &&
          !state.successModal.hidden
        ) {
          closeSuccess(state);
          updateMobileSticky(state);
        }
      }
    );
  }


  /* =========================================================
     MOBILE PREVIEW POSITION
     Sur mobile, l'ordre devient : choix des pays -> aperçu -> flocage.
     Sur desktop, l'aperçu reprend sa colonne d'origine.
     ========================================================= */

  function initResponsivePreviewPosition(state) {
    const previewColumn =
      state.section.querySelector(
        '.valorys-configurator__preview-column'
      );

    const countryStep =
      state.section.querySelector(
        '[data-valorys-country-step]'
      );

    if (!previewColumn || !countryStep) {
      return;
    }

    const desktopParent =
      previewColumn.parentNode;

    const desktopNextSibling =
      previewColumn.nextSibling;

    const media =
      window.matchMedia('(max-width: 749px)');

    const updatePosition = () => {
      if (media.matches) {
        if (previewColumn.previousElementSibling !== countryStep) {
          countryStep.insertAdjacentElement(
            'afterend',
            previewColumn
          );
        }
      } else if (previewColumn.parentNode !== desktopParent) {
        desktopParent.insertBefore(
          previewColumn,
          desktopNextSibling
        );
      }
    };

    updatePosition();

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', updatePosition);
    } else if (typeof media.addListener === 'function') {
      media.addListener(updatePosition);
    }
  }


  /* =========================================================
     INIT
     ========================================================= */

  async function init(
    root = document
  ) {
    const state =
      buildState(root);

    if (!state) return;

    ensureCdnHints();
    initResponsivePreviewPosition(state);

    populateCountrySelects(state);

    attachAutocomplete(
      state,
      state.selectA
    );

    attachAutocomplete(
      state,
      state.selectB
    );

    const urlConfiguration =
      readUrlConfiguration();

    const storedConfiguration =
      readStoredConfiguration(state);

    const defaultConfiguration = {
      version: CONFIG_VERSION,
      size: state.config.selectedSize || '',
      quantity: 1
    };

    const urlHasConfigurationValues =
      Boolean(
        urlConfiguration &&
        (
          urlConfiguration.countryA ||
          urlConfiguration.countryB ||
          urlConfiguration.size ||
          urlConfiguration.name ||
          urlConfiguration.number ||
          urlConfiguration.name2 ||
          new URLSearchParams(
            window.location.search
          ).has('v_floc') ||
          new URLSearchParams(
            window.location.search
          ).has('v_view')
        )
      );

    const initialConfiguration =
      urlHasConfigurationValues
        ? urlConfiguration
        : (
            storedConfiguration ||
            defaultConfiguration
          );

    applyConfiguration(
      state,
      initialConfiguration
    );

    if (
      urlConfiguration?.edit?.mainKey ||
      urlConfiguration?.edit?.serviceKey
    ) {
      state.editContext =
        urlConfiguration.edit;

      if (urlHasConfigurationValues) {
        /* On garde uniquement les clés d'édition dans l'URL.
         * Les modifications suivantes sont sauvegardées en local. */
        cleanValorysQueryParams(true);
      }
    } else if (urlConfiguration) {
      cleanValorysQueryParams(false);
    }

    toggleFlocageFields(state);
    updateViewUI(state);
    syncProperties(state);
    updateVariantAndPrice(state);

    bindEvents(state);
    initMobileSticky(state);

    await updateCanvas(state);

    saveCurrentConfiguration(state);

    scheduleWarmOppositeView(state);
    ensureRedigLoaded();

    document.fonts?.ready?.then(
      () => {
        if (
          state.isBack &&
          state.hasFlocage.checked
        ) {
          updateCanvas(
            state,
            true
          );
        }
      }
    );
  }


  /* =========================================================
     PUBLIC API
     ========================================================= */

  window.ValorysMaillot = {
    init
  };


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () =>
        init(document)
    );
  } else {
    init(document);
  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      init(
        event.target
      )
  );

})();